import { processEnv } from '../../utils';

const envID = processEnv.getEnvID();
export const AUTH_KEY = `${envID}8baseAuth`;
